/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type AddTeamMemberAuthTeamsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class AddTeamMemberAuthTeamsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: AddTeamMemberAuthTeamsResponse429ResponseBodyData;

  constructor(
    err: AddTeamMemberAuthTeamsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AddTeamMemberAuthTeamsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type AddTeamMemberAuthTeamsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class AddTeamMemberAuthTeamsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: AddTeamMemberAuthTeamsResponse409ResponseBodyData;

  constructor(
    err: AddTeamMemberAuthTeamsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AddTeamMemberAuthTeamsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type AddTeamMemberAuthTeamsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class AddTeamMemberAuthTeamsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: AddTeamMemberAuthTeamsResponse404ResponseBodyData;

  constructor(
    err: AddTeamMemberAuthTeamsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AddTeamMemberAuthTeamsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type AddTeamMemberAuthTeamsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class AddTeamMemberAuthTeamsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: AddTeamMemberAuthTeamsResponseResponseBodyData;

  constructor(
    err: AddTeamMemberAuthTeamsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AddTeamMemberAuthTeamsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type AddTeamMemberAuthTeamsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class AddTeamMemberAuthTeamsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: AddTeamMemberAuthTeamsResponseBodyData;

  constructor(
    err: AddTeamMemberAuthTeamsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AddTeamMemberAuthTeamsResponseBody";
  }
}

/**
 * Bad request
 */
export type AddTeamMemberResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class AddTeamMemberResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: AddTeamMemberResponseBodyData;

  constructor(
    err: AddTeamMemberResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "AddTeamMemberResponseBody";
  }
}

/** @internal */
export const AddTeamMemberAuthTeamsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    AddTeamMemberAuthTeamsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new AddTeamMemberAuthTeamsResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type AddTeamMemberAuthTeamsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AddTeamMemberAuthTeamsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    AddTeamMemberAuthTeamsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    AddTeamMemberAuthTeamsResponse429ResponseBody
  > = z.instanceof(AddTeamMemberAuthTeamsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const AddTeamMemberAuthTeamsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    AddTeamMemberAuthTeamsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new AddTeamMemberAuthTeamsResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type AddTeamMemberAuthTeamsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AddTeamMemberAuthTeamsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    AddTeamMemberAuthTeamsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    AddTeamMemberAuthTeamsResponse409ResponseBody
  > = z.instanceof(AddTeamMemberAuthTeamsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const AddTeamMemberAuthTeamsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    AddTeamMemberAuthTeamsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new AddTeamMemberAuthTeamsResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type AddTeamMemberAuthTeamsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AddTeamMemberAuthTeamsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    AddTeamMemberAuthTeamsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    AddTeamMemberAuthTeamsResponse404ResponseBody
  > = z.instanceof(AddTeamMemberAuthTeamsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const AddTeamMemberAuthTeamsResponseResponseBody$inboundSchema:
  z.ZodType<AddTeamMemberAuthTeamsResponseResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new AddTeamMemberAuthTeamsResponseResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type AddTeamMemberAuthTeamsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AddTeamMemberAuthTeamsResponseResponseBody$outboundSchema:
  z.ZodType<
    AddTeamMemberAuthTeamsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    AddTeamMemberAuthTeamsResponseResponseBody
  > = z.instanceof(AddTeamMemberAuthTeamsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const AddTeamMemberAuthTeamsResponseBody$inboundSchema: z.ZodType<
  AddTeamMemberAuthTeamsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new AddTeamMemberAuthTeamsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type AddTeamMemberAuthTeamsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AddTeamMemberAuthTeamsResponseBody$outboundSchema: z.ZodType<
  AddTeamMemberAuthTeamsResponseBody$Outbound,
  z.ZodTypeDef,
  AddTeamMemberAuthTeamsResponseBody
> = z.instanceof(AddTeamMemberAuthTeamsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const AddTeamMemberResponseBody$inboundSchema: z.ZodType<
  AddTeamMemberResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new AddTeamMemberResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type AddTeamMemberResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const AddTeamMemberResponseBody$outboundSchema: z.ZodType<
  AddTeamMemberResponseBody$Outbound,
  z.ZodTypeDef,
  AddTeamMemberResponseBody
> = z.instanceof(AddTeamMemberResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
